import React from 'react';
import { HeroSection } from './components/HeroSection';
import { TrainingMethod } from './components/TrainingMethod';
import { ContentSection } from './components/ContentSection';
import { ImaginateSection } from './components/ImaginateSection';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { UrgencySection } from './components/UrgencySection';
import { PurchaseSection } from './components/PurchaseSection';
import { FinalCTA } from './components/FinalCTA';
import { PurchasePopup } from './components/PurchasePopup';
const HERO_IMAGE_URL = 'https://cdn.magicpatterns.com/uploads/vXo5dMLUDpCXX5hUd2FB5U/ChatGPT_Image_Apr_27__2026__08_34_01_PM-removebg-preview.png';
export function App() {
  return <div className="min-h-screen bg-[#1a2e1a] text-[#faf5e8] selection:bg-[#faf5e8] selection:text-[#1a2e1a]" data-id="element-0">
      <HeroSection imageUrl={HERO_IMAGE_URL} data-id="element-1" />
      <TrainingMethod data-id="element-2" />
      <ContentSection data-id="element-3" />
      <ImaginateSection data-id="element-4" />
      <BonusSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <UrgencySection data-id="element-7" />
      <PurchaseSection data-id="element-8" />
      <FinalCTA data-id="element-9" />
      <PurchasePopup data-id="element-10" />
    </div>;
}